import { useTranslation } from 'react-i18next';

import type { Vorm } from '@/lib/melden/tekenen';
import { TekenCanvas } from './TekenCanvas';

interface Props {
  basis: HTMLCanvasElement | null;
  aan: boolean;
  onAan: (v: boolean) => void;
  toon: boolean;
  onToon: (v: boolean) => void;
  /** False when the readable picture failed: then "Gegevens tonen" is not offered. */
  kanTonen: boolean;
  vormen: Vorm[];
  onVormen: (v: Vorm[]) => void;
  onPin: (p: { x: number; y: number } | null) => void;
}

/** P3: send the screenshot or not; masked unless "Gegevens tonen" (with a warning); draw on it. */
export function BeeldBewerker({ basis, aan, onAan, toon, onToon, kanTonen, vormen, onVormen, onPin }: Props) {
  const { t } = useTranslation();
  if (!basis) return <output className="mt-4 block text-[13px] text-text-secondary">{t('melden.beeld.mislukt')}</output>;
  return (
    <div className="mt-4">
      <label className="flex items-center gap-1.5 text-[13px] text-text-primary">
        <input type="checkbox" checked={aan} onChange={(e) => onAan(e.target.checked)} />
        {t('melden.beeld.meesturen')}
      </label>
      {aan && (
        <>
          {kanTonen && (
            <label className="mt-2 flex items-center gap-1.5 text-[13px] text-text-primary">
              <input type="checkbox" checked={toon} onChange={(e) => onToon(e.target.checked)} />
              {t('melden.beeld.tonen')}
            </label>
          )}
          {toon && <p role="alert" className="mt-1 text-[12.5px] text-warning">{t('melden.beeld.waarschuwing')}</p>}
          <TekenCanvas basis={basis} vormen={vormen} onVormen={onVormen} onPin={onPin} />
        </>
      )}
    </div>
  );
}
